import { useTranslation } from 'react-i18next'
import { api } from '../api/client.js'
import { useApi } from '../api/useApi.js'
import { useAuth } from '../auth.jsx'
import { RankCard } from '../components/Clips.jsx'
import { pickI18n } from '../i18n'
import { ErrorState, Loading } from './states.jsx'

/** The ladder of titles; open to everyone, highlights the visitor's own progress. */
export default function RanksPage() {
  const { t, i18n } = useTranslation()
  const { profile } = useAuth()
  const { data, error, loading } = useApi(() => api.ranks())
  if (loading) return <Loading />
  if (error) return <ErrorState />
  const count = profile?.feed_count ?? 0
  return (
    <main className="mx-auto flex max-w-3xl flex-col gap-6 px-4 pt-10 pb-[72px] sm:px-8">
      <div className="flex flex-col gap-2">
        <h1 className="text-[clamp(32px,4vw,44px)] font-black tracking-[-1px]">{t('cabinet.ranks')}</h1>
        <p className="text-lg text-muted">{t('cabinet.ranksLead')}</p>
      </div>
      {profile ? <RankCard profile={profile} /> : null}
      <ol className="m-0 flex list-none flex-col gap-3 p-0">
        {data.map((r) => {
          const reached = profile && count >= r.min_feedings
          const current = profile?.rank?.key === r.key
          return (
            <li
              key={r.key}
              aria-current={current ? 'step' : undefined}
              className={`flex items-center gap-4 rounded-2xl border-[1.5px] p-4 ${current ? 'border-teal bg-mint' : 'border-line bg-surface'} ${profile && !reached ? 'opacity-60' : ''}`}
            >
              <span className="text-3xl" aria-hidden="true">{r.emoji}</span>
              <span className="flex flex-1 flex-col">
                <span className="text-lg font-extrabold">{pickI18n(r.name, i18n.resolvedLanguage)}</span>
                <span className="text-sm text-subtle">
                  {t('cabinet.level', { level: r.level })} · {t('cabinet.fromMeals', { count: r.min_feedings })}
                </span>
              </span>
              {reached ? <span className="text-xl font-black text-teal">✓</span> : null}
            </li>
          )
        })}
      </ol>
    </main>
  )
}
